import { FormEvent, useState } from "react";
import { Alert, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import Modal from "components/elements/Modal";
import Button, { EButtonVariant } from "components/elements/Button";
import { container } from "tsyringe";
import ProductSubscribedService from "services/ProductSubscribedService";
import { ValidationError } from "common/resources/Resource";

export default function RectificationModal({ productSubscribedId, onClose, onSaved }: { productSubscribedId: string; onClose: () => void; onSaved: () => void }) {
	const [document, setDocument] = useState<File | null>(null);
	const [proof, setProof] = useState<File | null>(null);
	const [accepted, setAccepted] = useState(false);
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState("");
	const submit = async (event: FormEvent) => {
		event.preventDefault();
		if (!document || !proof || !accepted || busy) return;
		setBusy(true);
		setError("");
		try {
			await container.resolve(ProductSubscribedService).attachHexaRectification(productSubscribedId, document, proof);
			onSaved();
			onClose();
		} catch (err) {
			setError(Array.isArray(err) ? (err as ValidationError[]).flatMap((e) => Object.values(e.constraints ?? {})).join(" ") : "Le rectificatif n’a pas pu être rattaché.");
		} finally {
			setBusy(false);
		}
	};
	return (
		<Modal isOpen onClose={onClose}>
			<Stack component="form" onSubmit={submit} spacing={2} sx={{ textAlign: "left", width: "100%" }}>
				<Typography variant="h6">Rattacher un rectificatif IQ-EQ</Typography>
				<Typography>
					Joignez le rectificatif signé qui identifie le bulletin d’origine, ainsi que sa preuve de signature. Le bulletin initial, ses preuves et sa date de validation
					seront conservés.
				</Typography>
				<label>
					Rectificatif signé (PDF)
					<input aria-label="Rectificatif signé (PDF)" type="file" accept="application/pdf" required onChange={(e) => setDocument(e.target.files?.[0] ?? null)} />
				</label>
				<label>
					Preuve de signature (PDF)
					<input aria-label="Preuve de signature (PDF)" type="file" accept="application/pdf" required onChange={(e) => setProof(e.target.files?.[0] ?? null)} />
				</label>
				<FormControlLabel
					control={<Checkbox checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />}
					label="IQ-EQ a validé le contenu du rectificatif et les personnes qui l’ont signé."
				/>
				{error && <Alert severity="error">{error}</Alert>}
				<Stack direction="row" spacing={2}>
					<Button variant={EButtonVariant.OUTLINED} onClick={onClose} disabled={busy}>
						Annuler
					</Button>
					<Button type="submit" loading={busy} disabled={!document || !proof || !accepted || busy}>
						Rattacher au dossier
					</Button>
				</Stack>
			</Stack>
		</Modal>
	);
}
